<template>
<div class="schulte-wrap">
  <div class="head">
    <div class="tabs">
      <div
        v-for="m in modes"
        :key="m.key"
        :class="{'tab': true, 'active': mode === m.key}"
        @click="switchMode(m.key)"
      >{{ m.name }}</div>
    </div>
  </div>
  <component :is="currentComp"/>
</div>
</template>

<script>
import Schulte5x5 from './schulte/Schulte5x5.vue'
import Schulte7x7 from './schulte/Schulte7x7.vue'
import SchulteCircle from './schulte/SchulteCircle.vue'
import SchulteCircle5x5 from './schulte/SchulteCircle5x5.vue'

export default {
  name: 'schulte-grid',
  components: { Schulte5x5, Schulte7x7, SchulteCircle, SchulteCircle5x5 },
  data () {
    return {
      mode: '5x5',
      modes: [
        { key: '5x5', name: '5×5 方形', comp: 'Schulte5x5' },
        { key: '7x7', name: '7×7 方形', comp: 'Schulte7x7' },
        { key: 'circle5', name: '5×5 圆形(大小不一)', comp: 'SchulteCircle5x5' },
        { key: 'circle', name: '7×7 圆形(大小不一)', comp: 'SchulteCircle' }
      ]
    }
  },
  computed: {
    currentComp () {
      const m = this.modes.find(e => e.key === this.mode)
      return m ? m.comp : 'Schulte5x5'
    }
  },
  methods: {
    switchMode (key) {
      this.mode = key
    }
  }
}
</script>

<style lang="scss" scoped>
.schulte-wrap{
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.head{
  padding: 16px 10px 0;
  text-align: center;
}
.tabs{
  margin-top: 0;
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0 10px;
}
.tab{
  padding: 8px 14px;
  font-size: #{'clamp(12px, 3.4vw, 14px)'};
  color: #333;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 20px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.15s, color 0.15s;
  &:hover{
    background-color: #e3f2fd;
  }
  &.active{
    background-color: #2196f3;
    color: #fff;
    border-color: #2196f3;
  }
}
</style>
